import "@/index.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { MusicGateProvider } from "@/context/MusicGateContext";
import { MusicGate } from "@/components/MusicGate";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import MusicPage from "@/pages/MusicPage";
import MerchPage from "@/pages/MerchPage";
import TourPage from "@/pages/TourPage";
import CheckoutPage from "@/pages/CheckoutPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";

function App() {
    useEffect(() => {
        document.title = "StillfadedWorld.com — Faded Keenan";
    }, []);

    return (
        <CartProvider>
            <MusicGateProvider>
                <BrowserRouter>
                    <div className="min-h-screen bg-brand-bg">
                        <Navbar />
                        <main>
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/music" element={<MusicPage />} />
                                <Route path="/merch" element={<MerchPage />} />
                                <Route path="/tour" element={<TourPage />} />
                                <Route path="/checkout" element={<CheckoutPage />} />
                                <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
                            </Routes>
                        </main>
                        <Footer />
                    </div>
                    <MusicGate />
                    <Toaster
                        position="bottom-right"
                        toastOptions={{
                            style: {
                                background: '#0A0A0A',
                                border: '1px solid rgba(255,255,255,0.1)',
                                color: '#F8FAFC',
                            },
                        }}
                    />
                </BrowserRouter>
            </MusicGateProvider>
        </CartProvider>
    );
}

export default App;
